import { makeAutoObservable, reaction } from 'mobx';

import { TReverseParam, reverseParams } from 'constants/extraParams';
import {
  TReverseMode,
  TReverseModes,
  TReverseSource,
  extractReverseModes,
  getEmptyReverseModes,
  reverseModesToFilterFields,
} from 'store/FilterStore/Mappers/ReverseModes';
import { RootStore } from 'store/RootStore';
import { SiteFeaturesIDs } from 'store/SiteFeatures/SiteFeatures';

class ReverseParams {
  root: RootStore;
  modes: TReverseModes;

  constructor(root: RootStore) {
    this.root = root;
    this.modes = getEmptyReverseModes();

    makeAutoObservable(this);

    reaction(
      () => this.isIncluded(reverseParams.adr),
      isIncluded => {
        if (!isIncluded) {
          this.root.filter.ADR.clear();
        }
      },
    );
  }

  get isEnabled() {
    return Boolean(this.root.siteFeatures.isSiteFeatureEnabled[SiteFeaturesIDs.reverseFilters]);
  }

  get excludedCount() {
    return Object.values(this.modes).filter(mode => mode === 'exclude').length;
  }

  get isDefault() {
    return Object.values(this.modes).every(mode => mode === null);
  }

  get requestData() {
    return reverseModesToFilterFields(this.modes);
  }

  isIncluded = (param: TReverseParam) => this.modes[param] === 'include';

  isExcluded = (param: TReverseParam) => this.modes[param] === 'exclude';

  setMode = (param: TReverseParam, mode: TReverseMode) => {
    this.modes[param] = this.modes[param] === mode ? null : mode;
  };

  fillFromFilterData = (filterData: TReverseSource) => {
    this.modes = extractReverseModes(filterData);

    if (this.modes.adr === 'include' && filterData.adr?.ids?.length) {
      this.root.filter.ADR.selectOptionsByIds(filterData.adr.ids);
    }
  };

  reset = () => {
    (Object.keys(this.modes) as TReverseParam[]).forEach(param => {
      this.modes[param] = null;
    });
  };
}

export { ReverseParams };
